import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { collection, doc, getDoc, query, getDocs } from 'firebase/firestore'
import { Alert } from 'react-alert'
import { DateTimePicker } from '@mui/x-date-pickers'
import * as moment from 'moment'
import 'moment/locale/fr'
import { auth } from '../../firebase'

import BlackLogo from '../../components/BlackLogo'
import updateCustomer from '../../utility/updateCustomer'
import deleteCustomer from '../../utility/deleteCustomer'
import saveCustomer from '../../utility/saveCustomer'
import updateUser from '../../utility/users/updateUser'
import Input from '../../components/Input'
import { ClearIcon } from '../../components/Icon'
import LoadingSpinner from '../../components/LoadingSpinner.js'
import { db } from '../../firebase'
import axios from 'axios'
import ENV from '../../env'

const AjoutNote = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const { customerId } = useParams()
	const [isLoading, setIsLoading] = useState(false)
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const [showErrorModal, setShowErrorModal] = useState(false)
	const [showIncompleteModal, setShowIncompleteModal] = useState(false)
	const [missingFields, setMissingFields] = useState([])
	const [showStaleModal, setShowStaleModal] = useState(false)
	const [isDirty, setIsDirty] = useState(false)
	const [showUnsavedModal, setShowUnsavedModal] = useState(false)
	const [pendingNavTarget, setPendingNavTarget] = useState(null)
	const [editingClient, setEditingClient] = useState(false)
	const [editedName, setEditedName] = useState('')
	const [editedFirstName, setEditedFirstName] = useState('')
	const [editedMail, setEditedMail] = useState('')
	const [editedPhoneNumber, setEditedPhoneNumber] = useState('')
	const [editedPostalCode, setEditedPostalCode] = useState('')
	const [editedShowroom, setEditedShowroom] = useState('')
	const [vendeurId, setVendeurId] = useState()
	const [customer, setCustomer] = useState()
	const [note, setNote] = useState()
	const [stat, setStat] = useState()
	const [action, setAction] = useState()
	const [date, setDate] = useState()
	const [project, setProject] = useState()
	const [title, setTitle] = useState('Cuisine')
	const [errors, setErrors] = useState({})
	const [showrooms, setShowrooms] = useState([])
	const [currentUser, setCurrentUser] = useState()
	const [currentUserEmail, setCurrentUserEmail] = useState()
	const [sales, setSales] = useState([
		{
			label: 'Vendeur',
			value: false,
		},
	])
	const [vendeurName, setVendeurName] = useState()
	const [salesUsers, setSalesUsers] = useState([]) // State to store the full user list including emails

	moment.locale('fr-FR')

	const getShowrooms = async () => {
		try {
			const q = query(collection(db, 'Showrooms'))
			const querySnapshot = await getDocs(q)
			const data = querySnapshot.docs.map((doc) => ({
				name: doc.data().name,
				id: doc.id,
			}))
			setShowrooms(data)
		} catch (error) {
			console.error('Error fetching showrooms:', error)
		}
	}

	const toggleEditClient = () => {
		if (!editingClient) {
			setEditedName(customer?.name || '')
			setEditedFirstName(customer?.firstName || '')
			setEditedMail(customer?.mail || '')
			setEditedPhoneNumber(customer?.phoneNumber || '')
			setEditedPostalCode(customer?.postalCode || '')
			setEditedShowroom(currentUser?.selectedShowroom || '')
		}
		setEditingClient((v) => !v)
	}

	const saveClientChanges = async () => {
		setIsLoading(true)
		try {
			await saveCustomer({
				id: customerId,
				name: editedName,
				firstName: editedFirstName,
				mail: editedMail,
				phoneNumber: editedPhoneNumber,
				postalCode: editedPostalCode,
			})
			setCustomer((prev) => ({
				...prev,
				name: editedName,
				firstName: editedFirstName,
				mail: editedMail,
				phoneNumber: editedPhoneNumber,
				postalCode: editedPostalCode,
			}))
			if (editedShowroom && editedShowroom !== currentUser?.selectedShowroom) {
				const updatedUser = { ...currentUser, selectedShowroom: editedShowroom }
				await updateUser(updatedUser.uid, updatedUser)
				setCurrentUser(updatedUser)
			}
			setEditingClient(false)
		} catch (error) {
			console.error('Erreur lors de la modification:', error)
			alert('La modification a échoué.')
		}
		setIsLoading(false)
	}

	const getCustomer = async () => {
		const customerRef = doc(db, 'Customers', customerId)

		getDoc(customerRef)
			.then((loadedCustomer) => {
				if (loadedCustomer.data()) {
					console.log(loadedCustomer.data())
					const data = loadedCustomer.data()
					setCustomer(data)
					setCustomer(data)
					setStat(data.stat || '')
					setAction(data.action || '')
					setDate(data.date || '')
					setProject(data.project || '')
					setNote(data.note || '')
					setTitle(data.title || 'Cuisine')
					setVendeurId(data.vendeur)
					setVendeurName(data.vendeur)
					setStat(data.stat || '')
					setVendeurId(data.vendeur)
					setVendeurName(data.vendeur)
					// Detect stale brouillon (no contactId + createdAt > 7 days ago)
					const isBrouillon = !data.contactId || data.contactId === 'none'
					if (isBrouillon && data.createdAt) {
						// Parse la date créée (format moment 'LLL' ou timestamp)
						let createdDate
						if (typeof data.createdAt === 'string') {
							// Format moment 'LLL' français
							createdDate = moment(data.createdAt, 'LLL', 'fr')
						} else if (data.createdAt.toDate) {
							// Firestore Timestamp
							createdDate = moment(data.createdAt.toDate())
						} else {
							// Assume timestamp en millisecondes
							createdDate = moment(data.createdAt)
						}

						if (createdDate.isValid()) {
							const daysDiff = moment().diff(createdDate, 'days')
							console.log('📅 Lead créé il y a', daysDiff, 'jours')
							if (daysDiff > 7) {
								console.log('⚠️ Lead en brouillon depuis plus de 7 jours')
								setShowStaleModal(true)
							}
						} else {
							console.warn('⚠️ Date de création invalide:', data.createdAt)
						}
					}
				} else {
					alert("Ce client n'existe pas.", {
						type: 'error',
					})
				}
			})
			.catch((err) =>
				alert("Ce client n'existe pas.", {
					type: 'error',
				}),
			)
	}

	const getSales = async () => {
		try {
			console.log('📋 Récupération de la liste des vendeurs via API...')

			// Utiliser la Cloud Function au lieu de lire directement Firestore
			const user = auth.currentUser
			if (!user) {
				console.error('❌ Utilisateur non authentifié')
				return
			}

			const token = await user.getIdToken()
			const response = await fetch(`${ENV.firebaseApiUrl}/user/list`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			})

			if (!response.ok) {
				throw new Error('Erreur lors de la récupération des vendeurs')
			}

			const users = await response.json()
			const salesData = users.map((user) => ({
				label: user.username,
				value: user.username,
				email: user.email,
			}))

			// Store the list with emails for later lookup
			setSalesUsers(salesData)

			console.log('✅ Vendeurs chargés:', salesData.length, 'utilisateurs')
			setSales([
				{
					label: 'Vendeur',
					value: false,
				},
				...salesData,
			])
		} catch (error) {
			console.error('❌ Erreur lors du chargement des vendeurs:', error)
			// Fallback: afficher au moins le vendeur actuel
			if (currentUser) {
				setSales([
					{
						label: 'Vendeur',
						value: false,
					},
					{
						label: currentUser.username,
						value: currentUser.username,
						email: currentUserEmail,
					},
				])
			}
		}
	}

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(async (user) => {
			if (!user) {
				// User is authenticated, allow access to protected routes
				navigate('/login')
			} else {
				const uid = user.uid

				// Check if document with ID equal to uid exists in the "Store" collection
				const storeRef = doc(collection(db, 'Users'), uid)
				const docSnapshot = await getDoc(storeRef)
				const userData = docSnapshot.data()
				setCurrentUserEmail(user.email)
				setCurrentUser(userData)
			}
		})

		return () => unsubscribe()
	}, [navigate])

	// Safe navigate: intercept if form is dirty
	const safeNavigate = (target) => {
		if (isDirty) {
			setPendingNavTarget(target)
			setShowUnsavedModal(true)
		} else {
			navigate(target)
		}
	}

	const confirmLeave = () => {
		setShowUnsavedModal(false)
		if (pendingNavTarget) navigate(pendingNavTarget)
	}

	const handleDelete = () => {
		setShowDeleteModal(true)
	}

	const confirmDelete = async () => {
		setShowDeleteModal(false)
		setIsLoading(true)
		try {
			await deleteCustomer(customerId)
			setIsDirty(false)
			navigate(`/vendeur/${vendeurId}`)
		} catch (error) {
			console.error('Erreur lors de la suppression:', error)
			alert('La suppression a échoué.')
			setIsLoading(false)
		}
	}

	const handleBrouillon = () => {
		const fields = [
			{ key: 'stat', label: 'Statut', value: stat },
			{ key: 'action', label: 'Action', value: action },
			{ key: 'date', label: 'Date', value: date },
			{ key: 'project', label: 'Projet', value: project },
			{ key: 'note', label: 'Note', value: note },
		]
		const empty = fields.filter((f) => !f.value).map((f) => f.label)
		if (empty.length > 0) {
			setMissingFields(empty)
			setShowIncompleteModal(true)
		} else {
			confirmBrouillon(false)
		}
	}

	const confirmBrouillon = async (autoFill) => {
		setShowIncompleteModal(false)
		setIsLoading(true)
		try {
			const selectedShowroom = currentUser?.selectedShowroom
			await updateCustomer(
				customerId,
				autoFill ? note || 'SKIPPED' : note,
				autoFill ? date || moment().format('LLL') : date,
				autoFill ? stat || 'B' : stat,
				autoFill ? action || 'Call' : action,
				autoFill ? project || 'Autre' : project,
				autoFill ? title || 'Autres' : title,
				selectedShowroom,
				vendeurName || vendeurId,
				'none',
				'none',
			)
			setIsDirty(false)
			navigate(`/vendeur/${vendeurId}`)
		} catch (error) {
			console.error('Erreur lors de la sauvegarde du brouillon:', error)
			setShowErrorModal(true)
		}
		setIsLoading(false)
	}

	useEffect(() => {
		getCustomer()
		getSales()
		getShowrooms()
	}, [customerId])

	const inputChangeHandler = (changeEvent) => {
		switch (changeEvent.target.id) {
			case 'Stat':
				setStat(changeEvent.target.value)
				break
			case 'Action':
				setAction(changeEvent.target.value)
				break
			case 'Date':
				setDate(changeEvent.target.value)
				break
			case 'Project':
				setProject(changeEvent.target.value)
				break
			case 'Title':
				setTitle(changeEvent.target.value)
				break
			case 'Note':
				setNote(changeEvent.target.value)
				break
			case 'Sales':
				console.log('🔄 Changement de vendeur:', changeEvent.target.value)
				setVendeurName(changeEvent.target.value)
				break
			default:
				console.log(`Not found ${changeEvent.target.id}.`)
		}
		setIsDirty(true)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		let formErrors = {}

		// Si la date est vide, mettre aujourd'hui à 1h plus tard par défaut
		let finalDate = date
		if (!date || date.trim() === '') {
			finalDate = moment().add(1, 'hour').format('LLL')
			setDate(finalDate)
			console.log('📅 Date vide détectée, date par défaut définie:', finalDate)
		}

		if (Object.keys(formErrors).length > 0) {
			setErrors(formErrors)
			return
		}

		const selectedShowroom = currentUser.selectedShowroom
		let crmContactId = 'none'
		let crmDealId = 'none'

		// Determine the correct Vendeur Email for the CRM payload
		let crmVendeurEmail = currentUserEmail

		if (vendeurName) {
			const selectedSale = salesUsers.find((user) => user.label === vendeurName)
			if (selectedSale && selectedSale.email) {
				crmVendeurEmail = selectedSale.email
			}
		}

		if (crmVendeurEmail === 'hello@monastudio.co') {
			crmVendeurEmail = 'it@couleurcuisine.be'
		}

		if (stat) {
			setIsLoading(true)

			// Helper to format date for API
			const formatDateForAPI = (dateStr) => {
				if (!dateStr) return new Date().toISOString()

				const months = {
					janvier: 0,
					février: 1,
					mars: 2,
					avril: 3,
					mai: 4,
					juin: 5,
					juillet: 6,
					août: 7,
					septembre: 8,
					octobre: 9,
					novembre: 10,
					décembre: 11,
				}

				// Strip "à HH:mm" if present, fall back to 01:00
				const cleaned = dateStr.replace(/ à .*$/, '').trim()
				const parts = cleaned.split(' ')

				if (parts.length >= 3) {
					const day = parseInt(parts[0])
					const month = months[parts[1].toLowerCase()]
					const year = parseInt(parts[2])

					if (!isNaN(day) && month !== undefined && !isNaN(year)) {
						// Extract time from original string if present
						const timeMatch = dateStr.match(/à (\d{1,2}):(\d{2})/)
						const hours = timeMatch ? parseInt(timeMatch[1]) : 1 // 01:00 par défaut
						const minutes = timeMatch ? parseInt(timeMatch[2]) : 0
						return new Date(year, month, day, hours, minutes).toISOString()
					}
				}

				return new Date().toISOString()
			}
			// 1. FIRST: Make CRM API call
			try {
				const crmPayload = {
					createdAt: new Date().toISOString().replace('Z', ''),
					vendeur: crmVendeurEmail,
					showroom:
						selectedShowroom === 'TEST' ? 'test rémi' : selectedShowroom,
					mail: customer?.mail || '',
					name: customer?.name || '',
					firstName: customer?.firstName || '',
					phoneNumber: customer?.phoneNumber || '',
					postalCode: customer?.postalCode || '',
					title: title,
					note: note,
					project: project,
					guess: customer?.guess || '',
					date: formatDateForAPI(date),
					action: action,
					stat: stat,
					type: customer?.type || '',
					id: customerId || '',
					prospecteur: currentUserEmail || '',
				}

				const crmResponse = await axios.post(
					`${process.env.REACT_APP_API_BASE_URL}/monastudio/v1/lead`,
					crmPayload,
					{
						headers: {
							'x-API-Key': `${process.env.REACT_APP_CRM_API_KEY}`,
							'Content-Type': 'application/json',
						},
					},
				)

				// Extract CRM IDs
				crmContactId = crmResponse.data.contact_id
				crmDealId = crmResponse.data.deal_id

				console.log('CRM IDs retrieved:', { crmContactId, crmDealId })
			} catch (error) {
				console.error("Erreur lors de l'ajout dans le CRM:", error)

				// Log detailed error information
				if (error.response) {
					console.error('Error Response Data:', error.response.data)
					console.error('Error Response Status:', error.response.status)

					let errorMessages = ''

					if (
						error.response.data?.detail &&
						Array.isArray(error.response.data.detail)
					) {
						errorMessages = error.response.data.detail
							.map((err, index) => {
								const field = err.loc ? err.loc.join(' > ') : 'Unknown field'
								return `${index + 1}. ${field}: ${err.msg}`
							})
							.join('\n')
					} else if (error.response.data?.detail) {
						errorMessages =
							typeof error.response.data.detail === 'string'
								? error.response.data.detail
								: JSON.stringify(error.response.data.detail, null, 2)
					} else {
						errorMessages = JSON.stringify(error.response.data, null, 2)
					}

					alert(`Erreur lors de l'ajout dans le CRM:\n\n${errorMessages}`)
				} else if (error.request) {
					console.error('Error Request:', error.request)
					alert("Erreur lors de l'ajout dans le CRM: Aucune réponse du serveur")
				} else {
					console.error('Error Message:', error.message)
					alert(`Erreur lors de l'ajout dans le CRM: ${error.message}`)
				}

				setIsLoading(false)
				return // Stop if CRM call fails
			}

			// 2. SECOND: Single Customer Update (with all data including CRM IDs if available)
			try {
				console.log('📤 Envoi du lead - Vendeur:', vendeurName || vendeurId)
				const updated = await updateCustomer(
					customerId,
					note,
					finalDate,
					stat,
					action,
					project,
					title,
					selectedShowroom,
					vendeurName || vendeurId,
					crmContactId,
					crmDealId,
				)

				if (!updated) {
					throw new Error('La mise à jour du client a échoué')
				}

				// State clearing and navigation
				setNote('')
				setStat()
				setCustomer()
				setAction()
				setDate()
				setProject()
				setTitle()
				setIsLoading(false)
				setIsDirty(false)

				navigate(
					location.search == '?scanned'
						? '/scan-confirmation'
						: `/confirmation/${vendeurId}`,
				)
			} catch (error) {
				console.error('Erreur lors de la mise à jour du client:', error)
				alert("La mise à jour du client n'a pas fonctionné.", {
					type: 'error',
				})
				setIsLoading(false)
			}
		} else {
			// This is for when stat is not set
			navigate(
				location.search == '?scanned'
					? '/scan-confirmation'
					: `/confirmation/${vendeurId}`,
			)
			setIsLoading(false)
		}
	}

	return (
		<div className="mobile-screen-wrapper">
			{/* ── Edit client modal ── */}
			{editingClient && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'flex-end',
						zIndex: 200,
					}}
					onClick={toggleEditClient}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '20px 20px 0 0',
							padding: '28px 20px 36px',
							width: '100%',
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<div className="d-flex justify-content-between align-items-center mb-4">
							<strong style={{ fontSize: '16px' }}>Modifier le lead</strong>
							<button
								type="button"
								className="border-0 bg-transparent p-0"
								style={{ fontSize: '20px', lineHeight: 1, color: '#6b7280' }}
								onClick={toggleEditClient}
							>
								✕
							</button>
						</div>
						<div className="d-flex flex-column gap-2 mb-3">
							<input
								className="form-control form--control"
								placeholder="Nom"
								value={editedName}
								onChange={(e) => setEditedName(e.target.value)}
							/>
							<input
								className="form-control form--control"
								placeholder="Prénom"
								value={editedFirstName}
								onChange={(e) => setEditedFirstName(e.target.value)}
							/>
							<input
								className="form-control form--control"
								placeholder="Email"
								type="email"
								value={editedMail}
								onChange={(e) => setEditedMail(e.target.value)}
							/>
							<input
								className="form-control form--control"
								placeholder="Téléphone"
								type="tel"
								value={editedPhoneNumber}
								onChange={(e) => setEditedPhoneNumber(e.target.value)}
							/>
							<input
								className="form-control form--control"
								placeholder="Code Postal"
								value={editedPostalCode}
								onChange={(e) => setEditedPostalCode(e.target.value)}
							/>
							<select
								className="form-control form--control form-select"
								value={editedShowroom}
								onChange={(e) => setEditedShowroom(e.target.value)}
							>
								<option value="">Showroom</option>
								{showrooms.map((s) => (
									<option key={s.id} value={s.name}>
										{s.name}
									</option>
								))}
							</select>
						</div>
						<button
							type="button"
							className="cmn-btn w-100"
							onClick={saveClientChanges}
						>
							{isLoading ? (
								<LoadingSpinner height="80%" width="30%" />
							) : (
								'Sauvegarder'
							)}
						</button>
					</div>
				</div>
			)}
			{showStaleModal && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 200,
						padding: '0 24px',
					}}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '12px',
							padding: '28px 24px 24px',
							width: '100%',
							maxWidth: '360px',
						}}
					>
						<p
							style={{ fontWeight: 700, fontSize: '17px', marginBottom: '6px' }}
						>
							Lead non traité
						</p>
						<p
							style={{
								color: '#6b7280',
								fontSize: '14px',
								marginBottom: '20px',
							}}
						>
							Ce lead est en brouillon NON ENREGISTRÉ. Souhaitez-vous le traiter
							maintenant ou enregistrer ?
						</p>
						<button
							className="cmn-btn w-100 mb-2"
							type="button"
							onClick={() => setShowStaleModal(false)}
						>
							Traiter maintenant
						</button>
						<button
							className="cmn-outline-btn w-100"
							type="button"
							onClick={() => {
								setShowStaleModal(false)
								confirmBrouillon(true)
							}}
						>
							Enregistrer en tant que brouillon
						</button>
					</div>
				</div>
			)}
			{showUnsavedModal && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 200,
						padding: '0 24px',
					}}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '12px',
							padding: '28px 24px 24px',
							width: '100%',
							maxWidth: '360px',
						}}
					>
						<p
							style={{ fontWeight: 700, fontSize: '17px', marginBottom: '6px' }}
						>
							Modifications non enregistrées
						</p>
						<p
							style={{
								color: '#6b7280',
								fontSize: '14px',
								marginBottom: '20px',
							}}
						>
							Vous avez des modifications non sauvegardées. Quitter sans
							enregistrer ?
						</p>
						<button
							className="cmn-btn w-100 mb-2"
							type="button"
							onClick={() => setShowUnsavedModal(false)}
						>
							Continuer à éditer
						</button>
						<button
							className="cmn-outline-btn w-100"
							type="button"
							onClick={confirmLeave}
						>
							Quitter sans enregistrer
						</button>
					</div>
				</div>
			)}
			{showIncompleteModal && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 200,
						padding: '0 24px',
					}}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '12px',
							padding: '28px 24px 24px',
							width: '100%',
							maxWidth: '360px',
						}}
					>
						<p
							style={{ fontWeight: 700, fontSize: '17px', marginBottom: '6px' }}
						>
							Certains champs sont vides
						</p>
						<p
							style={{
								color: '#6b7280',
								fontSize: '13px',
								marginBottom: '10px',
							}}
						>
							{missingFields.join(', ')}
						</p>
						<p style={{ fontSize: '14px', marginBottom: '20px' }}>
							Voulez-vous récupérer les informations déjà enregistrées pour ces
							champs ?
						</p>
						<button
							className="cmn-btn w-100 mb-2"
							type="button"
							onClick={() => confirmBrouillon(true)}
						>
							Oui, compléter automatiquement
						</button>
						<button
							className="btn btn-link w-100"
							type="button"
							style={{ fontSize: '13px', color: '#6b7280' }}
							onClick={() => setShowIncompleteModal(false)}
						>
							Annuler
						</button>
					</div>
				</div>
			)}
			{showErrorModal && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 200,
						padding: '0 24px',
					}}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '12px',
							padding: '32px 24px 24px',
							width: '100%',
							maxWidth: '360px',
							textAlign: 'center',
						}}
					>
						<p
							style={{
								fontWeight: 700,
								fontSize: '18px',
								marginBottom: '8px',
							}}
						>
							Erreur
						</p>
						<p
							style={{
								color: '#6b7280',
								fontSize: '14px',
								marginBottom: '24px',
							}}
						>
							La sauvegarde du brouillon a échoué.
						</p>
						<button
							className="cmn-btn w-100"
							type="button"
							onClick={() => setShowErrorModal(false)}
						>
							Fermer
						</button>
					</div>
				</div>
			)}
			{showDeleteModal && (
				<div
					style={{
						position: 'fixed',
						inset: 0,
						background: 'rgba(0,0,0,0.45)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 200,
						padding: '0 24px',
					}}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: '12px',
							padding: '32px 24px 24px',
							width: '100%',
							maxWidth: '360px',
							textAlign: 'center',
						}}
					>
						<p
							style={{ fontWeight: 700, fontSize: '18px', marginBottom: '8px' }}
						>
							Supprimer ce lead ?
						</p>
						<p
							style={{
								color: '#6b7280',
								fontSize: '14px',
								marginBottom: '24px',
							}}
						>
							Cette action est irréversible.
						</p>
						<button
							className="cmn-outline-btn w-100 mb-2"
							type="button"
							onClick={() => {
								setShowDeleteModal(false)
								confirmBrouillon(true)
							}}
						>
							Sauver et quitter
						</button>
						<div className="d-flex gap-2">
							<button
								className="cmn-outline-btn w-100"
								type="button"
								onClick={() => setShowDeleteModal(false)}
							>
								Annuler
							</button>
							<button
								className="cmn-btn w-100"
								type="button"
								style={{ background: '#e53e3e', borderColor: '#e53e3e' }}
								onClick={confirmDelete}
							>
								Supprimer
							</button>
						</div>
					</div>
				</div>
			)}
			<form onSubmit={handleSubmit} className="wrapper wrapper-inner">
				<div className="gap-border mb-3"></div>
				{/* ── Header ── */}
				<div className="d-flex justify-content-between align-items-center mb-3">
					<div>
						<p
							style={{
								fontSize: '11px',
								color: 'var(--base)',
								fontWeight: 700,
								letterSpacing: '0.08em',
								textTransform: 'uppercase',
								margin: 0,
							}}
						>
							{currentUser?.selectedShowroom || ''}
						</p>
						<h2
							className="title--small mb-0"
							style={{ fontSize: '22px', lineHeight: 1.1 }}
						>
							Note &amp; suivi
						</h2>
					</div>
					<button
						type="button"
						className="border-0 outline-0 bg-transparent"
						onClick={handleDelete}
					>
						<ClearIcon />
					</button>
				</div>
				{/* ── Client card ── */}
				<div
					className="mb-3 p-3"
					role="button"
					tabIndex={0}
					style={{
						background: '#fafafa',
						borderRadius: '10px',
						border: '1px solid var(--border)',
						cursor: 'pointer',
					}}
					onClick={toggleEditClient}
					onKeyDown={(e) => e.key === 'Enter' && toggleEditClient()}
				>
					<div className="mb-1">
						<span style={{ fontWeight: 700, fontSize: '15px' }}>
							{customer ? `${customer.firstName} ${customer.name}` : '—'}
						</span>
					</div>
					<div
						className="d-flex justify-content-between align-items-end"
						style={{ fontSize: '13px', color: '#6b7280', lineHeight: 1.7 }}
					>
						<div>
							{customer?.mail && <div>{customer.mail}</div>}
							{customer?.phoneNumber && <div>{customer.phoneNumber}</div>}
							{customer?.postalCode && <div>CP {customer.postalCode}</div>}
							{currentUser?.selectedShowroom && (
								<div>{currentUser.selectedShowroom}</div>
							)}
						</div>
						<span
							style={{
								fontSize: '12px',
								color: 'var(--base)',
								fontWeight: 600,
								whiteSpace: 'nowrap',
							}}
						>
							Modifier
						</span>
					</div>
				</div>
				<div className="ajout-note-info">
					<div className="item">
						<Input
							id="Stat"
							style={{ width: '90%', height: '56px' }}
							onChange={(e) => inputChangeHandler(e)}
							required="required"
							select={statData}
							value={stat || ''} // ← ajouter
						/>
					</div>
					<div className="item">
						<Input
							type="text"
							style={{ width: '100%', height: '56px' }}
							id="Action"
							onChange={(e) => inputChangeHandler(e)}
							required="required"
							select={actionData}
							value={action || ''} // ← ajouter
						/>
					</div>
					<div className="item">
						<Input
							// label="Je suis à la recherche d'informations pour un nouveau projet"
							style={{ width: '90%', height: '56px', marginTop: '-1rem' }}
							type="text"
							select={selectData}
							id="Project"
							onChange={(e) => inputChangeHandler(e)}
							required="required"
							value={project || ''}
						/>
					</div>
					<div className="item">
						<DateTimePicker
							label="Date/Heure"
							type="text"
							style={{ width: '100%' }}
							id="Date"
							onChange={(e) => {
								if (e && moment(e).isValid()) {
									const selectedMoment = moment(e)
									// Si l'heure est 00:00 (minuit), on met 01:00 par défaut
									if (
										selectedMoment.hour() === 0 &&
										selectedMoment.minute() === 0
									) {
										selectedMoment.hour(1).minute(0)
									}
									setDate(selectedMoment.format('LLL'))
									setIsDirty(true)
								}
							}}
							required="required"
							value={date ? moment(date, 'LLL', 'fr') : null}
							minDateTime={moment()}
							PopperProps={{
								sx: {
									'&.MuiPickersPopper-root': {
										border: '1px solid #e5e5e5 !important',
									},
								},
							}}
						/>
					</div>
					<div className="item">
						<Input
							type="text"
							style={{ width: '90%', height: '56px', marginTop: '-1rem' }}
							select={selectData2}
							id="Title"
							onChange={(e) => inputChangeHandler(e)}
							required="required"
							value={title || ''}
						/>
					</div>
					<div className="item">
						<Input
							type="text"
							style={{ width: '100%', height: '56px', marginTop: '-1rem' }}
							select={sales}
							id="Sales"
							onChange={(e) => inputChangeHandler(e)}
							value={vendeurName}
							required="required"
						/>
					</div>
				</div>
				<div className="item">
					{/* <Input
              placeholder="Date/Heure"
              type="text"
              style={{ width: "90%" }}
              id="Date"
              onChange={(e) => inputChangeHandler(e)}
              required="required"
            /> */}
				</div>
				<br />
				<textarea
					placeholder="Note..."
					className="form-control form--control mb-3"
					type="text"
					id="Note"
					value={note}
					onChange={(e) => inputChangeHandler(e)}
					required="required"
				></textarea>
				<div className="text-1 mb-3">Brève description du visiteur</div>
				<div className="__content-236 mt-auto mb-39px">
					{isLoading ? (
						<div className="cmn-btn w-100">
							<LoadingSpinner height="80%" width="30%" />
						</div>
					) : (
						<>
							<button className="cmn-btn mb-2 w-100" type="submit">
								Valider
							</button>
							<button
								className="cmn-outline-btn w-100"
								type="button"
								onClick={handleBrouillon}
							>
								Brouillon
							</button>
						</>
					)}
				</div>
				{/* <BlackLogo /> */}
			</form>
		</div>
	)
}

const selectData = [
	{
		label: 'Type',
		value: '',
	},
	{
		label: 'Neuf',
		value: 'Neuf',
	},
	{
		label: 'Rénovation',
		value: 'Rénovation',
	},
	{
		label: 'Immobilier',
		value: 'Immobilier',
	},
	{
		label: 'Inactif',
		value: 'Inactif',
	},
	{
		label: 'Autre',
		value: 'Autre',
	},
]

const statData = [
	{
		label: 'Stat: A, B, C, D',
		value: '',
	},
	{
		label: 'A',
		value: 'A',
	},
	{
		label: 'B',
		value: 'B',
	},
	{
		label: 'C',
		value: 'C',
	},
	{
		label: 'D',
		value: 'D',
	},
]

const actionData = [
	{
		label: 'Action: RDV/Call',
		value: '',
	},
	{
		label: 'RDV',
		value: 'RDV',
	},
	{
		label: 'Call',
		value: 'Call',
	},
]

const selectData2 = [
	{
		label: 'Cuisine',
		value: 'Cuisine',
	},
	{
		label: 'Placards',
		value: 'Placards',
	},
	{
		label: 'Dressing',
		value: 'Dressing',
	},
	{
		label: 'Concours',
		value: 'Concours',
	},
	{
		label: 'Autres',
		value: 'Autres',
	},
]

export default AjoutNote
